import { Fragment, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import config from "../../config";

const LogoutPage = (props) => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    
    useEffect(() => {		
        cookies.remove(config.cookiesName, { path: '/' });		
		navigate('/login');
        // eslint-disable-next-line
    },[])


    return (
        <Fragment>

        </Fragment>
    )
}
export default LogoutPage